(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (() => {
    const article = document.querySelector('.journal-landing');
    const guideSections = article?.querySelectorAll('.journal-guide__section');
    const careGuideSectionIds = [
      'understand-low-light',
      'best-natural-light',
      'water-less-often',
      'soil-and-drainage',
      'clean-and-rotate',
      'too-dark-warning-signs',
      'add-a-grow-light'
    ];
    const lightGuideSectionIds = [
      'window-direction',
      'north-facing-windows',
      'east-facing-windows',
      'west-facing-windows',
      'south-facing-windows',
      'distance-and-obstructions',
      'identify-low-light'
    ];
    const guideSectionIds = article?.dataset.articleUrl.includes('/what-is-low-light-for-houseplants')
      ? lightGuideSectionIds
      : careGuideSectionIds;
    guideSections?.forEach((section, index) => {
      if (guideSectionIds[index]) section.id = guideSectionIds[index];
    });
    if (!article?.dataset.articleUrl.includes('/best-low-light-houseplants')) return;
    const content = article.querySelector('.article-rte');
    if (!content) return;
    const firstPlant = [...content.querySelectorAll('h2')].find((heading) => /^1\./.test(heading.textContent.trim()));
    if (firstPlant) {
      const introNodes = [];
      let node = content.firstElementChild;
      while (node && node !== firstPlant) {
        introNodes.push(node);
        node = node.nextElementSibling;
      }
      const intro = document.createElement('section');
      intro.className = 'journal-landing__intro';
      const introInner = document.createElement('div');
      introInner.className = 'journal-landing__intro-inner';
      const introLead = document.createElement('div');
      introLead.className = 'journal-landing__intro-lead';
      introLead.innerHTML = '<p class="journal-landing__eyebrow">Before you choose a low-light plant</p><h2>Low light is often misunderstood</h2>';
      const introBody = document.createElement('div');
      introBody.className = 'journal-landing__intro-body';
      content.insertBefore(intro, content.firstElementChild);
      intro.append(introInner);
      introInner.append(introLead, introBody);
      introNodes.forEach((item) => introBody.append(item));
      const distinction = introBody.querySelector('aside strong:first-child');
      if (distinction?.textContent.trim().startsWith('First, an important distinction')) distinction.remove();
    }
    const allHeadings = [...content.querySelectorAll('h2')];
    const plantHeadings = allHeadings.filter((heading) => /^[1-3]\./.test(heading.textContent.trim()));
    plantHeadings.forEach((heading, index) => {
      const nodes = [];
      let current = heading;
      while (current && (current === heading || current.tagName !== 'H2')) {
        nodes.push(current);
        current = current.nextElementSibling;
      }
      const figure = nodes.find((item) => item.tagName === 'FIGURE');
      if (!figure) return;
      const section = document.createElement('section');
      section.className = 'journal-plant';
      const inner = document.createElement('div');
      inner.className = 'journal-plant__inner';
      const copy = document.createElement('div');
      copy.className = 'journal-plant__copy';
      const number = document.createElement('p');
      number.className = 'journal-plant__number';
      number.textContent = `Our low-light pick · 0${index + 1}`;
      content.insertBefore(section, heading);
      section.append(inner);
      copy.append(number);
      inner.append(copy, figure);
      figure.classList.add('journal-plant__media');
      nodes.forEach((item) => { if (item !== figure) copy.append(item); });
      const reasonsHeading = copy.querySelector('h3');
      const reasonsList = reasonsHeading?.nextElementSibling;
      if (reasonsHeading && reasonsList) {
        const reasons = document.createElement('div');
        reasons.className = 'journal-plant__reasons';
        reasons.append(reasonsHeading, reasonsList);
        const care = [...copy.querySelectorAll('p')].find((paragraph) => paragraph.querySelector('strong:first-child')?.textContent.trim().startsWith('Care note'));
        if (care) care.classList.add('journal-plant__care');
        copy.append(reasons);
        if (care) copy.append(care);
      }
      const productLink = figure.querySelector('a[href*="/products/"]');
      if (productLink) {
        const button = document.createElement('a');
        button.className = 'journal-landing__button';
        button.href = productLink.href;
        button.textContent = 'Shop this plant →';
        copy.append(button);
      }
    });
    const remainingHeadings = [...content.querySelectorAll(':scope > h2')];
    remainingHeadings.forEach((heading, index) => {
      const nodes = [];
      let current = heading;
      while (current && (current === heading || current.tagName !== 'H2')) {
        nodes.push(current);
        current = current.nextElementSibling;
      }
      const section = document.createElement('section');
      section.className = 'journal-info';
      const inner = document.createElement('div');
      inner.className = 'journal-info__inner';
      const eyebrow = document.createElement('p');
      eyebrow.className = 'journal-landing__eyebrow';
      eyebrow.textContent = index === remainingHeadings.length - 1 ? 'The takeaway' : 'Low-light essentials';
      content.insertBefore(section, heading);
      section.append(inner);
      inner.append(eyebrow);
      nodes.forEach((item) => inner.append(item));
    });
    const bottomLine = [...content.querySelectorAll('.journal-info')].find((section) => section.querySelector('h2')?.textContent.trim() === 'The bottom line');
    bottomLine?.remove();
    const healthySection = [...content.querySelectorAll('.journal-info')].find((section) => section.querySelector('h2')?.textContent.includes('How to keep low-light plants healthy'));
    if (healthySection) {
      const essentialsSection = healthySection.previousElementSibling?.classList.contains('journal-info')
        ? healthySection.previousElementSibling
        : [...content.querySelectorAll('.journal-info')].find((section) => section.querySelector('h2')?.textContent.includes('Why so many plants are incorrectly called low-light plants'));
      const shopButton = document.createElement('a');
      shopButton.className = 'journal-landing__button';
      shopButton.href = article.dataset.lowLightUrl;
      shopButton.textContent = 'Shop Low-Light Plants →';
      essentialsSection?.querySelector('.journal-info__inner')?.append(shopButton);
      healthySection.remove();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
